import React, { useState } from 'react';
import { useGetSubmissionsQuery } from '../store/adminApi';
import DataTable from './DataTable';
import Pagination from './Pagination';

const ITEMS_PER_PAGE = 10;

const FormList: React.FC = () => {
  const { data: submissions = [], error, isLoading } = useGetSubmissionsQuery();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  const filtered = (submissions as any[]).filter(s =>
    (s.title || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (s.assignee || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginated = filtered.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

  if (error) {
    return (
      <div className="text-center py-10 text-red-500">
        <p className="font-semibold">Error fetching forms.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
        <div>
          <h2 className="font-display font-bold text-xl text-trident-gray-900">All Submissions</h2>
          <p className="text-sm text-trident-gray-500">Total: {submissions.length} forms</p>
        </div>
        <div className="relative">
          <svg className="absolute left-3 top-1/2 -translate-y-1/2 text-trident-gray-400" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input
            type="text"
            value={searchTerm}
            onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            placeholder="Search by topic or assignee..."
            className="input-field pl-10 sm:w-72"
          />
        </div>
      </div>

      <DataTable
        loading={isLoading}
        rows={paginated}
        rowKey={(r) => r._id}
        emptyMessage={searchTerm ? `No forms match "${searchTerm}"` : 'No forms yet'}
        columns={[
          {
            key: 'sno', label: '#', width: '60px', align: 'center',
            render: (_r, i) => <span className="text-trident-gray-400 font-mono text-xs">{(currentPage - 1) * ITEMS_PER_PAGE + i + 1}</span>,
          },
          {
            key: 'title', label: 'Topic',
            render: (r) => <div className="font-semibold text-trident-gray-900">{r.title}</div>,
          },
          {
            key: 'assignee', label: 'Assignee',
            render: (r) => <span className="text-sm text-trident-gray-600">{r.assignee || 'N/A'}</span>,
          },
          {
            key: 'status', label: 'Status', align: 'center',
            render: (r) => r.status
              ? <span className="badge-green">✓ Submitted</span>
              : <span className="badge-gray">Pending</span>,
          },
          {
            key: 'published', label: 'Published', align: 'center',
            render: (r) => r.published
              ? <span className="badge-orange">✓ Live</span>
              : <span className="badge-gray">Draft</span>,
          },
        ]}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={filtered.length}
        itemsPerPage={ITEMS_PER_PAGE}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default FormList;
